<template>
  <div>
    <div class="content">
      <!-- 组件封装 -->
      <div class="video-view">
        <TCPlayer
          :chapter-info="chapterInfo"
          :dialog-open="worksDialogVisible"
        />
      </div>
      <div class="rightBox">
        <!-- 课程标题 -->
        <div class="rightBox-1">
          <h3>{{ courseDetails.name }}</h3>
          <span>{{ courseDetails.description }}</span>
          <!-- 授课老师展示 -->
          <div class="showTeacher">
            <div
              v-for="teacher in courseDetails.teachers"
              :key="teacher.id"
              class="teacher"
            >
              <div class="img"><img alt="" :src="teacher.headpic" /></div>
              <div>
                <span>{{ teacher.name }}</span
                ><span>{{ teacher.prefix }}</span>
              </div>
            </div>
          </div>
          <!-- 课程主要功能 -->
          <div class="CurriculumFunction">
            <!-- 作业按钮 要根据小节情况进行展示和上传，要根据当前播放情况决定显示和展示、上传等 -->
            <div class="function-1 cursor" @click="showDialog('attachs')">
              <div>
                <img
                  alt=""
                  :src="
                    $common.getResourceUrl(
                      'app/menu_course_details/menu_ziliao.png'
                    )
                  "
                />
              </div>
              <span>课件资料</span>

              <el-button
                v-if="chapterInfo && chapterInfo.attachs.length === 0"
                disabled
              />
            </div>

            <div
              v-if="chapterInfo && chapterInfo.is_work === 1"
              class="function-1 cursor"
              @click="showDialog('works')"
            >
              <div>
                <img
                  alt=""
                  :src="
                    $common.getResourceUrl(
                      'app/menu_course_details/menu_zuopin.png'
                    )
                  "
                />
              </div>
              <span>作业提交</span>
            </div>
          </div>
        </div>
        <!-- 课程目录 -->
        <div ref="subjectList" class="subjectList">
          <el-collapse
            v-if="courseDetails.has_section === 1"
            v-model="collSection"
            accordion
          >
            <el-collapse-item
              v-for="(item, index) in list"
              :key="index"
              :name="item.id"
            >
              <template slot="title">
                <i class="el-icon-s-claim"></i>{{ item.ident || '' }}
                {{ item.name }}
              </template>
              <div class="item">
                <div class="item-right">
                  <div v-if="item.chapters.length !== 0">
                    <div
                      v-for="chapter in item.chapters"
                      :key="chapter.id"
                      :ref="'chapterItem-' + chapter.id"
                      class="item-2"
                      :class="{ lock: chapter.is_lock === 1 }"
                      @click="chapterClick(chapter)"
                    >
                      <div
                        class="item-dw"
                        :class="{ changeBlueBox: chapter.id === activeChapter }"
                      >
                        <!-- 课程学习状态 -->
                        <div
                          class="dot"
                          :class="{ active: chapter.id === activeChapter }"
                        >
                          <span v-if="chapter.is_learn_over" class="over">
                            <icon-svg icon-class="duihao" />
                          </span>
                          <span v-else class="default"></span>
                        </div>
                      </div>
                      <div class="item-2-left">
                        <div
                          class="title"
                          :class="{ changeBlue: chapter.id === activeChapter }"
                        >
                          {{ chapter.ident || '' }} {{ chapter.title }}
                        </div>
                        <div
                          class="others"
                          :class="{
                            changeBlue: chapter.id === activeChapter,
                          }"
                        >
                          <span v-if="chapter.video_second_show">{{
                            chapter.video_second_show
                          }}</span>
                          <span
                            v-if="
                              chapter.is_lock === 1 && chapter.start_time_show
                            "
                            >{{ chapter.start_time_show }} 开课</span
                          >
                          <span v-if="chapter.is_lock === 0"
                            >{{
                              chapter.learn_log.progress === 0
                                ? '未学习'
                                : chapter.learn_log.progress >= 98
                                ? '已学完'
                                : `已学${chapter.learn_log.progress}%`
                            }}
                          </span>
                        </div>
                      </div>
                      <div v-if="chapter.is_lock" class="item-2-right lock">
                        <icon-svg icon-class="suoding" />
                      </div>
                      <div v-else class="item-2-right play">
                        <icon-svg icon-class="bofang" />
                      </div>
                    </div>
                  </div>
                  <div v-if="item.chapters.length === 0" class="ifnull">
                    此章节没有内容
                  </div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
          <div v-else class="el-collapse">
            <div
              v-for="(item, index) in list"
              :key="index"
              class="el-collapse-item"
            >
              <div class="item">
                <div class="item-right">
                  <div v-if="item.chapters.length !== 0">
                    <div
                      v-for="chapter in item.chapters"
                      :key="chapter.id"
                      :ref="'chapterItem-' + chapter.id"
                      class="item-2"
                      :class="{ lock: chapter.is_lock === 1 }"
                      @click="chapterClick(chapter)"
                    >
                      <div
                        class="item-dw"
                        :class="{ changeBlueBox: chapter.id === activeChapter }"
                      >
                        <!-- 课程学习状态 -->
                        <div
                          class="dot"
                          :class="{ active: chapter.id === activeChapter }"
                        >
                          <span v-if="chapter.is_learn_over" class="over">
                            <icon-svg icon-class="duihao" />
                          </span>
                          <span v-else class="default"></span>
                        </div>
                      </div>

                      <div class="item-2-left">
                        <div
                          class="title"
                          :class="{ changeBlue: chapter.id === activeChapter }"
                        >
                          {{ chapter.ident || '' }} {{ chapter.title }}
                        </div>
                        <div
                          class="others"
                          :class="{
                            changeBlue: chapter.id === activeChapter,
                          }"
                        >
                          <span v-if="chapter.video_second_show">{{
                            chapter.video_second_show
                          }}</span>
                          <span v-if="chapter.is_lock === 1"
                            >{{ chapter.start_time_show }} 开课</span
                          >
                          <span v-else
                            >{{
                              chapter.learn_log.progress === 0
                                ? '未学习'
                                : chapter.learn_log.progress >= 98
                                ? '已学完'
                                : `已学${chapter.learn_log.progress}%`
                            }}
                          </span>
                        </div>
                      </div>
                      <div v-if="chapter.is_lock" class="item-2-right lock">
                        <icon-svg icon-class="suoding" />
                      </div>
                      <div v-else class="item-2-right play">
                        <icon-svg icon-class="bofang" />
                      </div>
                    </div>
                  </div>
                  <div v-if="item.chapters.length === 0" class="ifnull">
                    此章节没有内容
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 课件下载 -->
    <el-dialog
      title="课件下载"
      :visible.sync="attachsDialogVisible"
      width="40%"
    >
      <div
        v-if="chapterInfo && chapterInfo.attachs.length > 0"
        class="itemContent"
      >
        <div
          v-for="(text, h) in chapterInfo.attachs"
          :key="h"
          class="contentText"
        >
          <span :title="text.title">{{ text.title }}</span>
          <span>{{ size(text.size) }}</span>
          <el-button
            v-if="text.can_down !== 0"
            @click="getInfo(chapterInfo.id, text.id)"
          >
            下载
          </el-button>
          <el-button v-else class="cur">
            <icon-svg icon-class="suoding" />
          </el-button>
        </div>
      </div>
      <div v-else>该小节无课件</div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="attachsDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 作业预览 -->
    <el-dialog :visible.sync="previewVisible" width="40%">
      <img alt="" :src="dialogImageUrl" width="100%" />
    </el-dialog>
    <!-- 作业提交 -->
    <el-dialog
      top="50px"
      :visible.sync="worksDialogVisible"
      width="790px"
      @close="taskCommitClose"
    >
      <div class="task_commit">
        <div class="title_task">
          <span class="title_span">作业内容</span>
        </div>
        <div class="title_comit">
          <span class="title_span">作业提交</span>
        </div>
        <div v-if="chapterInfo && chapterInfo.work_info" class="left">
          <!-- 左侧图 -->
          <div class="left_title">
            <!-- <span>作业内容</span> -->
          </div>
          <el-image
            fit="contain"
            :preview-src-list="[chapterInfo.work_info]"
            :src="chapterInfo.work_info"
          />
          <div class="foot" style="text-align: center; margin-top: 10px">
            <span>点击查看大图，右键保存</span>
          </div>
        </div>
        <!-- 中间分割线 -->
        <div
          v-if="chapterInfo && chapterInfo.work_info"
          class="middle_line"
        ></div>
        <div class="right">
          <div class="right_title">
            <!-- <span>作业提交</span> -->
          </div>

          <div class="upload">
            <el-upload
              ref="taskupload"
              action="#"
              :auto-upload="false"
              class="upload-demo"
              :file-list="fileListShow"
              :http-request="httpRequest"
              :limit="8"
              list-type="picture-card"
              :multiple="true"
              :on-change="change"
              :on-exceed="exceed"
              :on-preview="handlePreview"
              :on-progress="onProgress"
              :on-remove="handleRemove"
              :on-success="taskCommitSuccess"
              :show-file-list="true"
            >
              <el-button slot="trigger" size="small" type="primary"
                >选取文件</el-button
              >
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
            </el-upload>
          </div>

          <el-input
            v-model="introduction"
            :autosize="{ minRows: 10, maxRows: 10 }"
            maxlength="120"
            placeholder="请输入作业描述"
            type="textarea"
          />
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="worksDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="taskCommit">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getSubjectDetails, getSubjectInfo } from '@/network/request'
import { getSectionWithChapter } from '@/api/course'
import { taskCommit } from '@/api/task'
import TCPlayer from '@/components/TCPlayer.vue'
export default {
  name: 'CourseCatelogue',
  components: {
    TCPlayer,
  },
  props: {},
  data() {
    return {
      //父组件保留字段
      course_id: this.$route.params.id, // 传过来的课程id
      activeChapter: 0, // 课程大纲当前选中的小节id 也监听上一页面传过来得小节id
      collSection: 0, // 折叠面板 当前展开的大纲，非当前选中小节的大纲
      courseDetails: {}, // 课程详情
      list: null, //小节、大纲信息、视频信息
      chapterInfo: null, //当前播放小节信息
      attachsDialogVisible: false,
      worksDialogVisible: false,
      fileList: [],
      uploadTaskParams: {}, //提交作业的参数
      introduction: '', //提交作业的介绍
      fileListShow: [],
      previewVisible: false, //作业预览展示
      dialogImageUrl: '',
      learn_link_id: 7,
    }
  },
  computed: {
    // 换算单位
    size() {
      return (i) => {
        const kb = i / 1024
        if (kb < 1024) {
          return `${Math.round(kb)} KB`
        } else {
          return `${Math.round(kb / 1024)} MB`
        }
      }
    },
  },
  watch: {
    // 监听小节切换
    chapterInfo(e) {
      if (e) {
        this.sectionPosition()
        this.onlineInit()
      } else {
        this.closeConnect()
      }
    },
    //过滤换行回车
    // introduction(newvalue,oldvalue){
    //     console.log(newvalue.replace(/[\r\n]/g,""))
    //   this.introduction = this.introduction.replace(/[\r\n]/g,"")
    // }
  },
  mounted() {
    this.getSubjectDetails()
  },
  beforeDestroy() {
    this.onlineClose()
  },
  methods: {
    // 在线链接检查和处理
    onlineInit() {
      let params = this.$sockets.getLinkParams(this.learn_link_id)
      if (!params) {
        this.onlineCreate()
      } else {
        if (
          params.token != localStorage.getItem('user-token') ||
          params.course_id != this.course_id ||
          params.chapter_id != this.activeChapter
        ) {
          this.onlineClose()
          this.onlineCreate()
        }
      }
    },
    onlineCreate() {
      this.$sockets.createConnect(this.learn_link_id, {
        course_id: this.course_id,
        chapter_id: this.activeChapter,
      })
    },
    onlineClose() {
      this.$sockets.closeConnect(this.learn_link_id)
    },

    // 获取课程详情
    async getSubjectDetails() {
      const res = await getSubjectDetails(this.course_id, true)
      this.courseDetails = res.data.result
      if (this.$route.query.chapter_id) {
        this.activeChapter = Number(this.$route.query.chapter_id)
        //观看小节确定后建立ws连接
      } else {
        this.activeChapter = this.courseDetails.last_learn_chapter_id
      }
      this.getlist()
    },
    //获取大纲、小节、课件文件、视频信息
    async getlist() {
      const { data } = await getSectionWithChapter({
        course_id: this.course_id,
      })
      if (data.code === 0) {
        this.list = data.result
      }
      // 筛选最后学习的小节 或 第一节 进行自动播放
      this.list.some((el) => {
        let defaultChapter
        if (this.activeChapter) {
          defaultChapter = el.chapters.find((ch) => ch.id == this.activeChapter)
        } else {
          defaultChapter = el.chapters.find((ch) => ch.is_lock == 0)
        }
        if (defaultChapter) {
          this.chapterInfo = defaultChapter
          return true
        }
      })
    },
    // 定位到当前播放的章节
    sectionPosition() {
      //排除无上一级课程目录的情况
      if (this.chapterInfo.section_id != 0) {
        this.collSection = this.chapterInfo.section_id
      }
      this.$nextTick(() => {
        const refName = 'chapterItem-' + this.activeChapter
        if (this.$refs[refName][0]) {
          const goScroll =
            this.$refs[refName][0].offsetTop -
            this.$refs.subjectList.offsetTop -
            (this.$refs.subjectList.offsetHeight -
              this.$refs[refName][0].offsetHeight) /
              2
          let subjectListTop = this.$refs.subjectList.scrollTop
          const offset = subjectListTop > goScroll ? -10 : 10
          const timeTop = setInterval(() => {
            this.$refs.subjectList.scrollTop = subjectListTop += offset
            if (
              (offset > 0 && subjectListTop >= goScroll) ||
              (offset < 0 && subjectListTop <= goScroll)
            ) {
              clearInterval(timeTop)
            }
          }, 7)
        }
      })
    },
    // 跳转详情
    goXiangqing(item) {
      // 在新页面打开
      const routerJump = this.$router.resolve({
        name: 'COURSE_ATTACH',
        query: {
          course_id: item.page.param.course_id,
          subjectName: this.courseDetails.name,
        },
      })
      window.open(routerJump.href, '_blank')
    },

    // 课程点击
    chapterClick(chapter) {
      this.fileListShow = []
      this.fileList = []
      if (chapter.is_lock === 0) {
        //未锁定
        this.activeChapter = chapter.id
        //将对应的小节视频信息传给组件
        this.chapterInfo = chapter
      }
    },
    //对话框显示
    showDialog(param) {
      console.log(param)
      switch (param) {
        case 'attachs':
          this.attachsDialogVisible = true
          break
        case 'works':
          this.worksDialogVisible = true
          break

        default:
          break
      }
    },
    //下载
    async getInfo(chapterId, attachId) {
      const res = await getSubjectInfo({
        chapter_id: chapterId,
        attach_id: attachId,
      })
      this.subjectInfo = res.data.result
      location.href = res.data.result.object.down_url // 下载文件
    },
    //上传 组件内部手段上传 已被覆盖，调用不稳定
    submitUpload() {
      //默认上传
      try {
        this.$refs.taskupload.submit()
      } catch (e) {
        console.log(e)
      }
    },
    //提交
    taskCommit() {
      this.$confirm('是否确定上传选中作业?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          if (this.fileList.length > 0) {
            this.httpRequest()
          } else {
            this.$message({
              type: 'info',
              message: '请先选择要上传的文件',
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取上传',
          })
        })
    },
    //自定义上传
    httpRequest() {
      let Formdatas = new FormData()
      this.fileList.forEach((item, index) => {
        Formdatas.append(`files[${index}]`, item.raw)
      })
      Formdatas.append('chapter_id', this.chapterInfo.id)
      Formdatas.append('introduction', this.introduction)
      console.log(Formdatas)
      taskCommit(Formdatas).then((res) => {
        console.log(res)
        //上传成功后
        if (res.data.code === 0) {
          this.$message({
            message: '作业上传成功',
            type: 'success',
          })
          this.$refs.taskupload.clearFiles() //清空已上传的文件列表（该方法不支持在 before-upload 中调用）
          this.clearTaskCommitInfo()
          this.worksDialogVisible = false //关闭作业上传对话框
        }
      })
    },
    //清空已上传列表
    clearTaskCommitInfo() {
      this.fileListShow = [] //清空展示列表
      this.fileList = [] //清空上传文件列表
      this.introduction = '' //清空作业简介
    },
    //关闭对话框后
    taskCommitClose() {
      this.clearTaskCommitInfo()
    },
    //监听上传文件列表
    change(file, fileList) {
      console.log(fileList)
      this.fileList = fileList
      this.fileListShow.push({
        name: file.name,
        url: file.url,
      })
    },
    //
    exceed() {
      this.$message({
        message: '文件数量超出限制',
        type: 'errro',
      })
    },
    handleRemove(file, fileList) {
      console.log(fileList) //删除的文件
      const url = file.url
      this.fileListShow.map((el, index) => {
        if (url === el.url) {
          this.fileListShow.splice(index, 1)
        }
      })
    },
    //预览
    handlePreview(file) {
      this.previewVisible = true
      this.dialogImageUrl = file.url
    },
    //上传成功
    taskCommitSuccess() {
      console.log('作业上传成功')
    },
    //失败
    taskCommitError() {
      this.$message({
        message: '作业上传失败',
        type: 'error',
      })
    },
    //
    onProgress(event) {
      console.log(event)
    },
  },
}
</script>
<style scoped>
::v-deep(.tcp-vtt-thumbnail-img) {
  width: unset !important;
  height: unset !important;
}
</style>
<style lang="scss" scoped>
.changeBlue {
  color: #419cff !important;
}

.changeBlueBox::before {
  background-color: #419cff !important;
}

.el-icon-s-claim:before {
  color: #419cff;
}

.ifnull {
  margin-bottom: 20px;
  font-size: 12px;
  color: rgb(23, 184, 130);
}

.content {
  display: flex;
  width: 90%;
  height: 100vh;
  margin: 0 auto;
  min-width: 1100px;
  padding: 50px 20px 50px 20px;

  .video-view {
    position: relative;
    flex: 1;
    height: 100%;
    border-radius: 6px;
    margin-right: 42px;
    overflow: hidden;
  }

  .rightBox {
    width: 400px;
    height: 100%;

    // 课程简介
    .rightBox-1 {
      background-color: #ffffff;
      border-radius: 6px;
      padding: 20px;
      height: 220px;
      margin-bottom: 20px;
      overflow: hidden;
      border: 1px solid #f5f5f5;

      h3 {
        font-size: 20px;
        font-weight: normal;
        color: #141414;
        margin-bottom: 14px;
      }

      span {
        font-size: 13px;
        color: #999999;
      }

      .showTeacher {
        display: flex;
        margin-top: 20px;
        padding-bottom: 20px;
        border-bottom: 1px solid #e6e6e6;

        .teacher {
          display: flex;
          align-items: center;
          margin-right: 20px;

          div:nth-child(1) {
            width: 29px;
            height: 29px;
            background-color: #d8d8d8;
            border-radius: 50%;
            margin-right: 8px;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              display: block;
            }
          }

          div:nth-child(2) {
            display: flex;
            flex-direction: column;

            span:nth-child(1) {
              font-size: 13px;
              color: #666666;
              margin-bottom: 5px;
            }

            span:nth-child(2) {
              font-size: 10px;
              color: #999999;
            }
          }
        }
      }

      .CurriculumFunction {
        display: flex;
        justify-content: flex-start;
        padding-top: 15px;

        .function-1 {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-width: 50px;
          margin-right: 10px;
          .el-button {
            border: 0;
            position: absolute;
            opacity: 0.6;
            height: 55px;
            width: 58px;
            background-color: #ffffff;
          }
          div {
            width: 23px;
            height: 23px;
            margin-bottom: 9px;
          }

          span {
            display: inline-block;
            text-align: center;
            width: 57px;
          }

          img {
            width: 100%;
            height: 100%;
            display: block;
          }
        }
      }
    }

    //   课程目录
    .subjectList {
      background-color: #ffffff;
      border-radius: 6px;
      height: calc(100% - 220px - 20px);
      overflow-y: auto;
      border: 1px solid #f5f5f5;

      &::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 2px;
        /*高宽分别对应横竖滚动条的尺寸*/
      }

      &::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        background: #d8d8d8;
      }

      &::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        background: transparent;
      }

      .el-collapse {
        border: 0;

        ::v-deep(.el-collapse-item__header) {
          padding-left: 14px;
          height: 55px;
          font-size: 16px;
          font-weight: normal;
          color: #141414;

          &.is-active {
            background-color: rgba(65, 156, 255, 0.15);
          }

          i {
            margin-right: 12px;
          }
        }

        ::v-deep(.el-collapse-item__content) {
          padding: 0;
        }
      }

      .item {
        padding-top: 20px;

        .item-right {
          width: 100%;
          padding-left: 50px;
          padding-right: 20px;
        }

        .item-2 {
          position: relative;
          display: flex;
          align-items: center;
          background-color: #f8f9fa;
          border-radius: 8px;
          padding: 16px;
          margin-bottom: 15px;
          line-height: 1.7;
          cursor: pointer;

          &.lock {
            cursor: default;

            span {
              color: #999999 !important;
            }
          }

          .item-dw {
            position: absolute;
            width: 20px;
            height: 100%;
            left: -30px;
            top: 50%;
            margin-top: -6px;

            > .dot {
              position: absolute;
              width: 15px;
              height: 15px;
              line-height: 15px;
              text-align: center;
              border-radius: 50%;
              left: -0;
              background-color: #d8d8d8;
              color: #fff;
              display: flex;
              align-items: center;
              justify-content: center;

              &.active {
                background-color: #419cff;
              }

              .default {
                display: inline-block;
                width: 7px;
                height: 7px;
                border-radius: 50%;
                background-color: #fff;
              }

              .over {
                font-size: 15px;
              }
            }

            &::after {
              content: '';
              position: absolute;
              width: 1px;
              height: calc(100% - 20px);
              top: 18px;
              left: 7px;
              background-color: rgba(197, 197, 197, 0.2);
              margin-top: 6px;
            }
          }

          &:last-child {
            .item-dw::after {
              display: none;
            }
          }

          .item-2-left {
            display: flex;
            flex-direction: column;
            width: 230px;
            margin-right: 32px;

            .title {
              font-size: 15px;
              color: #141414;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .others {
              font-size: 12px;
              color: #999999;

              > span {
                margin-right: 10px;
              }
            }
          }

          .item-2-right {
            background-color: #e5effa;
            text-align: center;
            color: #419cff;
            width: 30px;
            height: 22px;
            line-height: 22px;
            font-size: 11px;
            border-radius: 8px;

            &.lock {
              background-color: #fff;
              width: 28px;
              height: 28px;
              font-size: 14px;
              line-height: 28px;
              border-radius: 50%;
              color: #9a9a9a;
            }
          }
        }
      }
    }
  }
}
.itemContent {
  padding: 1px 20px;
  // border-top: 1px solid #eee;
  // background: #dee1e4;
  // margin-bottom: 30px;
  // margin-top: 10px;
  border-radius: 6px;

  .contentText {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;
    font-size: 15px;
    color: #666666;

    span:first-child {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    span:nth-child(2) {
      width: 80px;
      text-align: center;
      margin-right: 60px;
      margin-left: 50px;
    }

    .el-button {
      background: none;
      margin-left: 30px;
      padding: 0;
      width: 60px;
      height: 28px;
      line-height: 28px;
      color: #666;
      font-weight: 400;
    }
  }

  .contentText:last-child {
    margin-bottom: 0;
  }
}
$uploadheight: 600px;
.task_commit {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 600px;

  .title_task {
    position: absolute;
    top: 30px;
    left: 80px;
    .title_span {
      font-size: 22px;
      font-weight: 600;
      color: #828282;
    }
  }
  .title_comit {
    position: absolute;
    top: 30px;
    left: 460px;
    .title_span {
      font-size: 22px;
      font-weight: 600;
      color: #828282;
    }
  }
  .left {
    // background-color: #419cff;
    width: 30%;
    height: $uploadheight;
    .el-image {
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
    .left_title {
      // margin: 20px 12px;
      padding: 10px 20px;
      span {
        font-size: 20px;
      }
    }
    .foot {
      span {
        font-size: 10px;
        padding: 5px 15px;
      }
    }
  }
  .middle_line {
    width: 2px;
    height: 700px;
    background: #82828275;
    margin: 40px 10px 0px 10px;
  }
  .right {
    padding: 10px 10px;
    width: 70%;
    // background-color: #419cff;
    overflow-y: auto;
    height: $uploadheight;
    .right_title {
      padding-left: 5px;
      padding-bottom: 10px;
      span {
        font-size: 20px;
      }
    }
    .card_preview {
      position: absolute;
      left: 50%;
      top: 50%;
      z-index: 99;
      transform: translate(-50%, -50%);
    }
    .upload {
      width: 100%;
      margin-bottom: 20px;
      // max-height: 400px;
      // background-color: #999999;
    }
  }
}
</style>
